import React, { useState, useEffect } from "react";
import style from "./Items.module.scss";
import Files from "./NewPost/Files/Files";
import {
  Button,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  ButtonGroup,
  Row,
  Col,
  Table,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import ChangesModal from "./ChangesModal";
import { useSelector } from "react-redux";
import { getPersonTypeName } from "../../AlertSimple/Fields/types";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import LaddaButton, { SLIDE_DOWN, SLIDE_LEFT } from "react-ladda";
import { accountProps } from "../../Order/Form/commons";
import { getLocalDate } from "../../../../utils";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import DuplicatedPeople from "./subsummary/duplicatedPeople";
import InvestorProfile from "./subsummary/investorProfile";
import { showToast } from "../../../../utils/Helper";

function Summary(props) {
  const {
    description,
    title,
    personType,
    typeAlias,
    files,
    relateds,
    alert,
    fetchs,
    loadingAlert,
    alertId,
    reftag,
    days,
    status,
    role,
    markFalseCoincidence,
    processes,
    requestClosure,
    name,
    closedAccountDate,
    closedAccount,
    dispatch,
    Link,
    trigger,
    personInfo,
    refId,
    antiClientDetails,
    accountsRelated,
    enabledAlertFeatures,
  } = props;

  const [closing, setClosing] = useState(0);
  const [loadingCloseAccount, SetLoadingCloseAccount] = useState(false);
  const [showMessageCloseAccount, SetShowMessageCloseAccount] = useState(false);
  const [sending, setROS] = useState(0);
  const [info, setInfo] = useState();
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [updateKYCStatus, setUpdateKYCStatus] = useState(false);
  const [alertFeatures, setAlertFeatures] = useState(null);
  const [availableSteps, setAvailableSteps] = useState([]);
  const [selectedStep, setSelectedStep] = useState(null);
  const [loadingSteps, setLoadingSteps] = useState(false);
  const [allowedActions, setAllowedActions] = useState(null);
  const [riskResults, setRiskResults] = useState(null);
  const [advisorComments, setAdvisorComments] = useState("");
  const [complianceComments, setComplianceComments] = useState("");

  // Consumir el servicio getAvailableAlertSteps solo para TransactionalLimit
  useEffect(() => {
    // Solo llamar si el tipo de alerta está habilitado
    const isEnabled =
      enabledAlertFeatures &&
      enabledAlertFeatures.AlertType &&
      enabledAlertFeatures.AlertType.some((t) => t.AlertTypeInternalName === processes && t.AlertTypeEnabled);

    if (
      (processes === "TransactionalLimit" || processes === "RiskChange") &&
      enabledAlertFeatures &&
      enabledAlertFeatures.AlertType &&
      enabledAlertFeatures.AlertType.length > 0 &&
      isEnabled
    ) {
      // prevenir llamadas si no hay id de alerta
      if (!alertId) return;
      const AlertTypeId = enabledAlertFeatures.AlertType[0].AlertTypeId;
      setLoadingSteps(true);
      fetchs.getAvailableAlertSteps({ id: alertId }, (response) => {
        if (response && response.SDTAlertTransition) {
          const steps = response.SDTAlertTransition.map((step) => ({
            id: step.AlertStepTransitionId,
            name: step.AlertStepTransitionName,
            canChangeStep: step.canChangeStep,
          }));

          setAvailableSteps(steps);
        } else {
          setAvailableSteps([]);
        }
        setLoadingSteps(false);
      });
    }
  }, [processes, enabledAlertFeatures, alertId, alert]);

  useEffect(() => {
    if (alertId) {
      fetchs.getAlertAllowedActions({ AlertId: alertId }, (response) => {
        if (response && response.AlertAllowedActions) {
          setAllowedActions(response.AlertAllowedActions);
        }
      });
    }
  }, [alertId]);

  useEffect(() => {
    if (alertId) {
      fetchs.calculateCurrentFutureRiskScores({ alertEventId: alertId }, (response) => {
        if (response && response.riskResults) {
          setRiskResults(response.riskResults);
        } else {
          setRiskResults(null);
        }
      });
    }
  }, [alertId]);

  useEffect(() => {
    fetchs.getComplianceEventComments({ alertEventId: alertId }, (response) => {
      if (response && response.SDTComplianceCommentsInOut) {
        setAdvisorComments(response.SDTComplianceCommentsInOut.advisorComment || "");
        setComplianceComments(response.SDTComplianceCommentsInOut.complianceComment || "");
      }
    });
  }, [alertId]);

  useEffect(() => {
    fetchs.getParameterValue({ ParameterName: "UpdateKYCStatus" }, (response) => {
      if (response) {
        setUpdateKYCStatus(response.SdtParametersData.ParameterNumericValue == 1);
      }
    });
  }, [updateKYCStatus]);

  useEffect(() => {
    if (
      (reftag && processes === "TransactionalLimit") ||
      processes === "RiskChange" ||
      (reftag && processes === "KYC")
    ) {
      try {
        let newInfo = JSON.parse(reftag);
        setInfo(newInfo);
      } catch (e) {
        setInfo();
      }
    }
  }, [reftag]);

  const openChild = (child) => {
    dispatch({ type: "TOGGLE_CHILD_ALERT", alert: child });
  };

  const downloadPdf = () => {
    fetchs.downloadPdf({ eventId: alertId });
  };

  const checkFalseCoincidence = (falseCoincidence) => {
    const body = {
      complianceEventid: alertId,
      falseCoincidence: falseCoincidence,
    };
    fetchs.falseCoincidenceCheckList(body);
    dispatch({
      type: "CHECKLIST_COINCIDENCE",
      alert: falseCoincidence,
    });
  };

  const closeAccount = () => {
    SetLoadingCloseAccount(true);
    fetchs.closeAccountAlert(
      {
        eventId: alertId,
        accountId: typeAlias,
      },
      (response) => {
        SetLoadingCloseAccount(false);
        SetShowMessageCloseAccount(true);
      }
    );
  };

  const closeAlert = () => {
    setClosing({ loading: true });

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: "Closed",
      },
      (response) => {
        setClosing(1);

        dispatch({ type: "ALERT_UPDATE", alert: { status: "Closed" } });
      }
    );
  };

  const getJournalEntryId = (linea) => {
    const partes = linea.split(",");
    if (partes.length < 2) {
      return "";
    }
    const journalEntryId = partes[0].trim().split(":")[1].trim();
    return journalEntryId;
  };

  const alertToROS = () => {
    setROS({ loading: true });

    fetchs.updateStatus(
      {
        eventId: alertId,
        statusCompliance: "ROS",
      },
      (response) => {
        setROS(1);

        dispatch({ type: "ALERT_UPDATE", alert: { status: "ROS" } });
      }
    );
  };

  // Chequeo si el tipo de alerta actual está habilitado
  const isAlertTypeEnabled =
    enabledAlertFeatures &&
    enabledAlertFeatures.AlertFlowEnabled &&
    enabledAlertFeatures.AlertType &&
    enabledAlertFeatures.AlertType.some((t) => t.AlertTypeInternalName === processes && t.AlertTypeEnabled);

  const hasNoPermissionStep =
    availableSteps &&
    availableSteps.length > 0 &&
    availableSteps.some((step) => step.canChangeStep === false);

  const changedItems =
    info && Array.isArray(info) ? info.filter((i) => String(i.oldValueName) !== String(i.newValueName)) : [];
  const changedCount = changedItems.length;

  if (!isAlertTypeEnabled) {
    return (
      <div className={style.summary}>
        <div className={style.title}>
          <h5>
            {processes == "KYC" ||
            processes == "Flags" ||
            processes == "ExternalImport" ||
            processes == "RiskChanges" ? (
              description
            ) : processes == "CheckList" || processes == "TransactionalLimit" ? (
              <div>{title}</div>
            ) : processes == "TransLimitChanges" && description ? (
              <div>{description.split(".")[0]}</div>
            ) : (
              <div>
                {getPersonTypeName(personType)}
                {": "}
                {typeAlias} {title}
              </div>
            )}
          </h5>
          <div className="text-right">
            {(status == "Closed" || closing == 1) && (
              <Button color="primary btn-sm" onClick={() => downloadPdf()}>
                <i className="fa fa-download"></i>
              </Button>
            )}
            {((status != "Closed" &&
              status != "ROS" &&
              closing != 1 &&
              processes != "RiskChanges" &&
              role == "Compliance") ||
              (processes == "ExternalImport" && status != "Closed") ||
              (role == "CEO" && processes == "RiskChanges" && status != "Closed")) && (
              <LaddaButton
                className={"btn btn-ladda btn-primary"}
                loading={closing.loading}
                onClick={() => closeAlert()}
                data-style={SLIDE_DOWN}
              >
                Close alert
              </LaddaButton>
            )}
          </div>
        </div>
        <div className={style.related}>
          <div className={style.left}>
            {processes === "CheckList" && (
              <div>
                <p>{`${trigger}(${reftag})`}</p>
                <strong>Details</strong>
                {(!antiClientDetails ||
                  antiClientDetails.length == 0 ||
                  (antiClientDetails[0] == "" && !antiClientDetails[1])) && <p>No details</p>}
                {antiClientDetails.length > 0 && (
                  <div>
                    <ListGroup flush>
                      {antiClientDetails.map((item, index) => (
                        <ListGroupItem className="p-3" key={index}>
                          {item.split("-").map((part, index) => (
                            <span key={index}>
                              {part
                                .split(":")
                                .map((part2, index) =>
                                  part2.startsWith("'") && part2.endsWith("'") ? (
                                    <strong>{part2.replace(/'/g, "") + ":"}</strong>
                                  ) : (
                                    part2 + " "
                                  )
                                )}
                            </span>
                          ))}
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </div>
                )}
                <strong>Client</strong>
                <p>
                  <Link to={`/person/${typeAlias}`} target="_blank">
                    {`${name}(${
                      personInfo.PhysicalPersonMainDocumentNumber
                        ? personInfo.PhysicalPersonMainDocumentNumber
                        : typeAlias
                    })`}
                  </Link>
                </p>
                <p>{description.includes("spouse") && description}</p>
                <strong>Accounts related</strong>
                {accountsRelated.length == 0 && <p>No accounts</p>}
                {accountsRelated.length > 0 && (
                  <div>
                    {accountsRelated.map((account, index) => (
                      <p key={index}>
                        <Link to={`/account/${account.AccountId}`} target="_blank">
                          {`${account.Relationship} - ${account.AccountId} - ${account.AccountName}`}
                        </Link>
                      </p>
                    ))}
                  </div>
                )}
              </div>
            )}
            {processes === "ExternalImport" && description.includes("duplicated people") ? (
              <div>
                <DuplicatedPeople alert={alert} fetchs={fetchs} Link={Link} closeAlert={closeAlert} />
              </div>
            ) : processes == "InvestorProfile" ? (
              <div>{processes == "InvestorProfile" && <InvestorProfile investorProfile={trigger} />}</div>
            ) : (
              ((processes != "InvestorProfile" &&
                processes !== "TransactionalLimit" &&
                processes !== "CheckList" &&
                processes != "RiskChanges") ||
                (processes === "ExternalImport" && !description.includes("duplicated people"))) && (
                <div>
                  <div>
                    <strong>Data related</strong>
                    {processes === "TransLimitChanges" && description ? (
                      <div>
                        <p>{"Transactional Limit Changes "}</p>
                        <p>{reftag.split("*")[0]}</p>
                        <p>{reftag.split("*")[1]}</p>
                        <p>{reftag.split("*")[2]}</p>
                        <p>
                          <LaddaButton
                            className={"btn btn-ladda btn-primary"}
                            loading={sending.loading}
                            onClick={() => alertToROS()}
                            data-style={SLIDE_LEFT}
                          >
                            Mark as ROS
                          </LaddaButton>
                        </p>
                      </div>
                    ) : (
                      <p>
                        {processes === "KYC" || processes === "Flags" || reftag === "CLOSEACCOUNT" ? (
                          trigger.split("--").map((linea, index) => <p key={index}>{linea}</p>)
                        ) : processes == "ExternalImport" ? (
                          reftag
                        ) : processes === "Onboarding" ? (
                          <Link
                            to={`/${
                              description.includes("Person")
                                ? "Person"
                                : role == "Compliance"
                                ? "account"
                                : "position"
                            }/${refId}`}
                            target="_blank"
                          >
                            {description}
                          </Link>
                        ) : (
                          description
                        )}
                      </p>
                    )}
                  </div>
                  {processes === "Precheck" && (
                    <div>
                      <strong> Precheck Details</strong>
                      <p>{reftag}</p>
                    </div>
                  )}
                  {(processes === "KYC" || processes === "Flags") && reftag !== "" && (
                    <div>
                      <strong>Flags</strong>
                      <p>{reftag}</p>
                    </div>
                  )}
                  {status != "Closed" &&
                    status != "ROS" &&
                    sending != 1 &&
                    processes == "KYC" &&
                    role == "Compliance" &&
                    updateKYCStatus && (
                      <div>
                        <LaddaButton
                          className={"btn btn-ladda btn-primary"}
                          loading={sending.loading}
                          onClick={() => alertToROS()}
                          data-style={SLIDE_LEFT}
                          style={{ marginBottom: "10px" }}
                        >
                          KYC not approved
                        </LaddaButton>
                      </div>
                    )}
                </div>
              )
            )}
          </div>

          {(processes == "TransactionalLimit" ||
            (processes == "KYC" && enabledAlertFeatures.AlertFlowEnabled)) && (
            <div>
              <div className={style.left}>
                <div>
                  <strong>Advisor Expiration Date: </strong>
                  <span>
                    {alert.advisorExpirationReviewDate && alert.advisorExpirationReviewDate !== "0000-00-00"
                      ? alert.advisorExpirationReviewDate
                      : "Alert has not yet been submitted to the advisor"}
                  </span>
                </div>
                <strong>Details</strong>

                <p>
                  {trigger.trim() == "Quantity limit in deposits" ||
                  trigger.trim() == "Quantity limit in Withdraws" ||
                  trigger.trim() == "Amount limit in deposits" ||
                  trigger.trim() == "Amount limit in Withdraws"
                    ? role == "Advisor"
                      ? reftag.split(";").map((linea, index) =>
                          linea.includes("JournalEntryId:") ? (
                            <a href={`/#/crossReference/JournalEntry/${getJournalEntryId(linea)}`}>
                              {linea} <br />
                            </a>
                          ) : (
                            <p key={index}>
                              {linea} {"\n"}{" "}
                            </p>
                          )
                        )
                      : reftag.split(";").map((linea, index) => (
                          <p key={index}>
                            {linea} {"\n"}
                          </p>
                        ))
                    : trigger}
                </p>

                {processes != "RiskChange" && info !== undefined && info !== "" ? (
                  <InfoTable info={info} processes={processes} />
                ) : (
                  ""
                )}

                {status != "Closed" &&
                  status != "ROS" &&
                  sending != 1 &&
                  role == "Compliance" &&
                  processes !== "KYC" && (
                    <LaddaButton
                      className={"btn btn-ladda btn-primary"}
                      loading={sending.loading}
                      onClick={() => alertToROS()}
                      data-style={SLIDE_LEFT}
                    >
                      Mark as ROS
                    </LaddaButton>
                  )}
              </div>
            </div>
          )}

          <span className={style.right}>
            {relateds != null && (
              <RelatedDDown relateds={relateds} openChildAlert={openChild}>
                <React.Fragment>
                  <span className={style.btnRelated} disabled={relateds.length == 0}>
                    <i className="fa fa-bell"></i>
                    <Badge pill color="danger" className={style.badge}>
                      {relateds.length}
                    </Badge>
                  </span>
                </React.Fragment>
              </RelatedDDown>
            )}
          </span>
        </div>
        {requestClosure ? (
          <Row style={{ marginBottom: "5px" }}>
            <Col lg={12}>
              {closedAccount ? (
                <div style={{ color: "mediumseagreen" }}>
                  The account {name} is Closed - Date of closure: {getLocalDate(closedAccountDate)}
                </div>
              ) : (
                <div>
                  <div>
                    <strong>Close Account</strong>
                  </div>
                  {showMessageCloseAccount ? (
                    <div style={{ color: "mediumseagreen" }}>The account was successfully closed</div>
                  ) : (
                    <div>
                      Do you want to Close Account {name}?
                      <LaddaButton
                        style={{ float: "right" }}
                        className="btn btn-ladda btn-primary mb-2"
                        loading={loadingCloseAccount}
                        disabled={false}
                        onClick={() => closeAccount()}
                        data-style={SLIDE_LEFT}
                      >
                        Confirm
                      </LaddaButton>
                    </div>
                  )}
                </div>
              )}
            </Col>
          </Row>
        ) : (
          <div />
        )}
        {processes == "CheckList" ? (
          <Row style={{ marginBottom: "5px" }}>
            <Col lg={12}>
              <div>
                <strong>Person Checklist</strong>
              </div>
              Do you want to mark this person as a false coincidence? If you select yes this alert wont be
              generated again next time
              <ButtonGroup style={{ float: "right" }}>
                <Button
                  onClick={() => checkFalseCoincidence(true)}
                  color={markFalseCoincidence === true ? "success btn btn-sm" : "primary btn btn-sm"}
                  active={markFalseCoincidence === true}
                >
                  YES
                </Button>
                <Button
                  onClick={() => checkFalseCoincidence(false)}
                  color={markFalseCoincidence === false ? "danger btn btn-sm" : "primary btn btn-sm"}
                  active={markFalseCoincidence === false}
                >
                  NO
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        ) : (
          <div></div>
        )}

        <Files
          hideDelete
          loading={loadingAlert}
          personType={personType}
          alias={typeAlias}
          fetchs={{
            downloadFile: fetchs.downloadFile,
            fileTypes: fetchs.fileTypes,
            send: fetchs.send,
          }}
          files={files}
        />
      </div>
    );
  }
  // Render con lógica nueva (puedes adaptar aquí para los botones dinámicos)
  if (
    status === "Closed" &&
    enabledAlertFeatures &&
    enabledAlertFeatures.AlertFlowEnabled &&
    enabledAlertFeatures.AlertType &&
    enabledAlertFeatures.AlertType.some((t) => t.AlertTypeInternalName === processes && t.AlertTypeEnabled) &&
    alert &&
    alert.stepId &&
    alert.stepName
  ) {
    return (
      <div className={style.summary}>
        <div className={style.title}>
          <h5>{description}</h5>
          <div className="text-right">
            <Button color="primary btn-sm" onClick={downloadPdf}>
              <i className="fa fa-download"></i>
            </Button>
          </div>
        </div>
        {/* Si el desarrollo nuevo está activo y hay stepId, muestra Last Step */}
        {enabledAlertFeatures &&
          enabledAlertFeatures.AlertFlowEnabled &&
          alert &&
          alert.stepId &&
          alert.stepName && (
            <div style={{ marginBottom: "10px" }}>
              <strong>Last Step:</strong> {alert.stepName}
            </div>
          )}
        {/* Details, info, archivos, etc. igual que antes */}
        <div className={style.left}>
          <div style={{ marginBottom: "15px" }}>
            <strong>Go to Person: </strong>
            <Link to={`/person/${typeAlias}`} target="_blank" style={{ textDecoration: "underline" }}>
              {name ? name : "View Profile"} ({typeAlias})
            </Link>
          </div>
          <div>
            <strong>Advisor Expiration Date: </strong>
            <span>
              {alert.advisorExpirationReviewDate && alert.advisorExpirationReviewDate !== "0000-00-00"
                ? alert.advisorExpirationReviewDate
                : "Alert has not yet been submitted to the advisor"}
            </span>
            <strong>Data related: </strong>
            {processes === "KYC" &&
              trigger.split("--").map((linea, index) => <span key={index}>{linea}</span>)}
          </div>

          {processes !== "RiskChange" && (
            <React.Fragment>
              <strong>Details</strong>
              <p>
                {trigger.trim() == "Quantity limit in deposits" ||
                trigger.trim() == "Quantity limit in Withdraws" ||
                trigger.trim() == "Amount limit in deposits" ||
                trigger.trim() == "Amount limit in Withdraws"
                  ? role == "Advisor"
                    ? reftag.split(";").map((linea, index) =>
                        linea.includes("JournalEntryId:") ? (
                          <a href={`/#/crossReference/JournalEntry/${getJournalEntryId(linea)}`}>
                            {linea} <br />
                          </a>
                        ) : (
                          <p key={index}>
                            {linea} {"\n"}{" "}
                          </p>
                        )
                      )
                    : reftag.split(";").map((linea, index) => (
                        <p key={index}>
                          {linea} {"\n"}
                        </p>
                      ))
                  : trigger}
              </p>
            </React.Fragment>
          )}
          {processes != "RiskChange" && info !== undefined && info !== "" ? <InfoTable info={info} /> : ""}

          {processes === "RiskChange" && (
        <div>

          <div className={style.changeSummaryRow}>
            <span className={style.changeSummaryText}>→ {changedCount} fields changed</span>
            <Button color="link" onClick={() => setDetailsOpen(true)}>
              Display changes
            </Button>
          </div>

          <ChangesModal
            isOpen={detailsOpen}
            toggle={() => setDetailsOpen(!detailsOpen)}
            info={info}
            changedCount={changedCount}
            alert={alert}
            riskResults={riskResults}
            role={role}
            advisorComments={advisorComments}
            complianceComments={complianceComments}
            fetchs={{ upsertComplianceEventComments: fetchs.upsertComplianceEventComments }}
          />
            </div>
          )}
        </div>
        <Files
          hideDelete
          loading={loadingAlert}
          personType={personType}
          alias={typeAlias}
          fetchs={{
            downloadFile: fetchs.downloadFile,
            fileTypes: fetchs.fileTypes,
            send: fetchs.send,
          }}
          files={files}
        />
      </div>
    );
  }

  return (
    <div className={style.summary}>
      <div className={style.title}>
        <h5>{description}</h5>
        <div className="text-right">
          {(status === "Closed" || closing === 1) && (
            <Button color="primary btn-sm" onClick={downloadPdf}>
              <i className="fa fa-download"></i>
            </Button>
          )}
        </div>
      </div>
      <div className={style.left}>
        <div style={{ marginBottom: "15px" }}>
          <strong>Go to Person: </strong>
          <Link to={`/person/${typeAlias}`} target="_blank" style={{ textDecoration: "underline" }}>
            {name ? name : "View Profile"} ({typeAlias})
          </Link>
        </div>
        <div>
          <strong>Advisor Expiration Date: </strong>
          <span>
            {alert.advisorExpirationReviewDate && alert.advisorExpirationReviewDate !== "0000-00-00"
              ? alert.advisorExpirationReviewDate
              : "Alert has not yet been submitted to the advisor"}
          </span>
          {processes == "KYC" && (
                    <div>
                      <strong>Data related: </strong>
                      {trigger.split("--").map((linea, index) => (
                        <span key={index}>{linea}</span>
                      ))}
                    </div>
                  )}
        </div>

        {processes !== "RiskChange" && (
          <React.Fragment>
            <strong>Details</strong>
            <p>
              {trigger.trim() == "Quantity limit in deposits" ||
              trigger.trim() == "Quantity limit in Withdraws" ||
              trigger.trim() == "Amount limit in deposits" ||
              trigger.trim() == "Amount limit in Withdraws"
                ? role == "Advisor"
                  ? reftag.split(";").map((linea, index) =>
                      linea.includes("JournalEntryId:") ? (
                        <a href={`/#/crossReference/JournalEntry/${getJournalEntryId(linea)}`}>
                          {linea} <br />
                        </a>
                      ) : (
                        <p key={index}>
                          {linea} {"\n"}{" "}
                        </p>
                      )
                    )
                  : reftag.split(";").map((linea, index) => (
                      <p key={index}>
                        {linea} {"\n"}
                      </p>
                    ))
                : trigger}
            </p>
          </React.Fragment>
        )}
      </div>

      {(processes === "TransactionalLimit" || processes === "RiskChange" || processes === "KYC") &&
        renderAllowedButtons(
          allowedActions,
          closing,
          sending,
          alertToROS,
          closeAlert,
          fetchs,
          alertId,
          processes
        )}

      {/* SOLO renderiza el dropdown si TODOS los steps tienen canChangeStep === true */}
      {status !== "Rejected" &&
        (processes === "TransactionalLimit" &&
          (availableSteps.length > 0 && availableSteps.every((step) => step.canChangeStep === true))) && (
          <SendStepDropdown
            alert={alert}
            availableSteps={availableSteps}
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            loadingSteps={loadingSteps}
            onSend={() => {
              fetchs.sendToStep &&
                fetchs.sendToStep({ id: alertId, stepId: selectedStep.id }, () => setSelectedStep(null));
            }}
          />
        )}

      {/* Si hay al menos un step con canChangeStep === false, solo muestra el current step */}
      {/* {processes === "TransactionalLimit" && alert.stepId && alert.stepName && (
        <div className={style.stepDropdownContainer}>
          <div className={style.stepDropdownLabel}>
            <strong>Current Step: </strong>
            <span>{alert.stepName}</span>
          </div>
        </div>
      )} */}

      {processes != "RiskChange" && info !== undefined && info !== "" && (
        <InfoTable info={info} processes={processes} />
      )}

      {processes === "RiskChange" && (
        <div>

          <div className={style.changeSummaryRow}>
            <span className={style.changeSummaryText}>→ {changedCount} fields changed</span>
            <Button color="link" onClick={() => setDetailsOpen(true)}>
              Display changes
            </Button>
          </div>

          <ChangesModal
            isOpen={detailsOpen}
            toggle={() => setDetailsOpen(!detailsOpen)}
            info={info}
            changedCount={changedCount}
            alert={alert}
            riskResults={riskResults}
            role={role}
            advisorComments={advisorComments}
            complianceComments={complianceComments}
            fetchs={{ upsertComplianceEventComments: fetchs.upsertComplianceEventComments }}
          />
        </div>
      )}       
      <Files
        hideDelete
        loading={loadingAlert}
        personType={personType}
        alias={typeAlias}
        fetchs={{
          downloadFile: fetchs.downloadFile,
          fileTypes: fetchs.fileTypes,
          send: fetchs.send,
        }}
        files={files}
      />
    </div>
  );
}

const RelatedDDown = ({ children, relateds, openChildAlert }) => (
  <UncontrolledDropdown>
    <DropdownToggle nav style={{ paddingRight: "0px" }}>
      {children}
    </DropdownToggle>
    {relateds.length != 0 && (
      <DropdownMenu right>
        <DropdownItem header tag="div">
          <strong>Relateds alerts</strong>
        </DropdownItem>
        {relateds &&
          relateds.map((r, i) => (
            <DropdownItem key={`rel-${r.id}-${i}`} onClick={() => openChildAlert(r)}>
              <i className="fa fa-bell text-primary"></i> {r.title} {r.description}
            </DropdownItem>
          ))}
      </DropdownMenu>
    )}
  </UncontrolledDropdown>
);

export const LoadingMessage = ({ text }) => (
  <div className={style.loadingMessage}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

function SendStepDropdown({ alert, availableSteps, selectedStep, setSelectedStep, onSend, loadingSteps }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [noPermission, setNoPermission] = useState(false);

  const handleToggle = () => setDropdownOpen((open) => !open);

  const handleSelectStep = (step) => {
    setSelectedStep(step);
    setDropdownOpen(false);
    if (step.canChangeStep === false) {
      setNoPermission(true);
    } else {
      setNoPermission(false);
    }
  };

  return (
    <div className={style.stepDropdownContainer}>
      <div className={style.stepDropdownLabel}>
        {alert.stepId && alert.stepId !== 0 && (
          <div>
            <strong>Current Step: </strong>
            <span>{alert.stepName}</span>
          </div>
        )}
      </div>
      <strong>Send to role/step: </strong>
      <div className={style.stepDropdownControlsRow}>
        {loadingSteps ? (
          <span className={style.stepDropdownLoading}>
            <CircularProgress sm style={{ margin: "0px" }} /> Loading...
          </span>
        ) : availableSteps && availableSteps.length > 0 ? (
          <div className={style.stepDropdownFlex}>
            <Dropdown isOpen={dropdownOpen} toggle={handleToggle} className={style.stepDropdown}>
              <DropdownToggle caret className={style.stepDropdownToggle}>
                {selectedStep ? selectedStep.name : "Select step"}
              </DropdownToggle>
              <DropdownMenu className={style.stepDropdownMenu}>
                {availableSteps.map((step, idx) => (
                  <DropdownItem
                    key={step.id || idx}
                    onClick={() => handleSelectStep(step)}
                    className={style.stepDropdownItem}
                  >
                    {step.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            {selectedStep && selectedStep.canChangeStep && (
              <Button color="primary" className={style.stepDropdownSendBtn} onClick={onSend}>
                Send
              </Button>
            )}
          </div>
        ) : (
          <span className={style.stepDropdownNoSteps}>No steps available</span>
        )}
        {noPermission && (
          <div className={style.noPermissionMessage}>
            <i className="fa fa-ban" style={{ marginRight: "6px" }} />
            <span>No permissions</span>
          </div>
        )}
      </div>
    </div>
  );
}

function InfoTable({ info, processes }) {
  if (!info || info === "" || !Array.isArray(info)) {
    return null;
  }

  return (
    <Table className={style.table}>
      <thead>
        <tr>
          <th>Info</th>
          <th>{processes === "KYC" ? "Details" : "Total"}</th>
        </tr>
      </thead>
      <tbody>
        {info.map((i) => (
          <tr key={`t-${i.key}`}>
            <td>{i.key}</td>
            <td>
              <FormattedNumber value={i.value} decimalScale={0} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

function renderAllowedButtons(
  allowedActions,
  closing,
  sending,
  alertToROS,
  closeAlert,
  fetchs,
  alertId,
  processes
) {
  if (!allowedActions) return null;

  return (
    <div className={style.allowedActionsRow}>
      {allowedActions.ROS && processes !== "KYC" && (
        <LaddaButton
          className={"btn btn-ladda btn-primary btn-sm"}
          loading={sending.loading}
          onClick={alertToROS}
          data-style={SLIDE_LEFT}
        >
          Mark as ROS
        </LaddaButton>
      )}
      {allowedActions.ROS && processes === "KYC" && (
        <LaddaButton
          className={"btn btn-ladda btn-primary btn-sm"}
          loading={sending.loading}
          onClick={alertToROS}
          data-style={SLIDE_LEFT}
        >
          KYC not approved
        </LaddaButton>
      )}
      {allowedActions.Close && processes !== "RiskChange" && (
        <LaddaButton
          className={"btn btn-ladda btn-primary btn-sm"}
          loading={closing.loading}
          onClick={closeAlert}
          data-style={SLIDE_DOWN}
        >
          Close alert
        </LaddaButton>
      )}
      {allowedActions.ToAdvisor &&
        (processes === "TransactionalLimit" || processes === "RiskChange" || processes === "KYC") && (
          <Button
            color="primary btn-sm"
            onClick={() =>
              fetchs.updateStatus &&
              fetchs.updateStatus({ eventId: alertId, statusCompliance: "WorkingAdvisor" }, () => {})
            }
          >
            Send to Advisor
          </Button>
        )}
      {allowedActions.ToSecondApproval &&
        (processes === "TransactionalLimit" || processes === "RiskChange") && (
          <Button
            color="primary btn-sm"
            onClick={() =>
              fetchs.sendToStep &&
              fetchs.updateStatus({ eventId: alertId, statusCompliance: "WorkingCEO" }, () => {})
            }
          >
            Second Approval
          </Button>
        )}
      {allowedActions.ToCompliance &&
        (processes === "TransactionalLimit" || processes === "RiskChange" || processes === "KYC") && (
          <Button
            color="primary btn-sm"
            onClick={() =>
              fetchs.updateStatus &&
              fetchs.updateStatus({ eventId: alertId, statusCompliance: "WorkingCompliance" }, () => {})
            }
            style={{ marginTop: "7px" }}
          >
            Send To Compliance
          </Button>
        )}
      {allowedActions.Close && processes === "RiskChange" && (
        <Button
          color="primary btn-sm"
          onClick={() =>
            fetchs.confirmAlertChanges &&
            fetchs.confirmAlertChanges({ ComplianceEventid: alertId, Action: "Approve" }, (response) => {
              if (response && response.result && response.result.Code === 200) {
                showToast(response.result.Description, false); // Éxito
              } else {
                showToast(response.result.Description, true); // Error
              }
            })
          }
        >
          Approve changes
        </Button>
      )}
      {allowedActions.Rejected && processes === "RiskChange" && (
        <Button
          color="primary btn-sm"
          onClick={() =>
            fetchs.confirmAlertChanges &&
            fetchs.confirmAlertChanges({ ComplianceEventid: alertId, Action: "Reject" }, (response) => {
              if (response && response.result && response.result.Code === 200) {
                showToast(response.result.Description, false); // Éxito
              } else {
                showToast(response.result.Description, true); // Error
              }
            })
          }
        >
          Reject changes
        </Button>
      )}
    </div>
  );
}

export default Summary;
